<template>
  <component :is="activeComponent" />
</template>

<script>
import { mapState } from "vuex";
import BookingsOrganizer from "./BookingsOrganizer.vue";
import BookingsPhotographer from "./BookingsPhotographer.vue";

export default {
  name: "BookingsPageRouter",
  components: {
    BookingsOrganizer,
    BookingsPhotographer,
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
    }),
    userRole() {
      return this.user?.role;
    },
    activeComponent() {
      switch (this.userRole) {
        case "organizer":
          return "BookingsOrganizer";
        case "photographer":
          return "BookingsPhotographer";
        default:
          return null;
      }
    },
  },
  watch: {
    userRole(role) {
      if (!role || !this.activeComponent) {
        this.$router.replace("/");
      }
    },
  },
  created() {

    if (!this.userRole || !this.activeComponent) {
      this.$router.replace("/");
    }
  },
};
</script>
